<template>
  <TvChart
    id="trading-view-chart"
    :symbol="symbolInfo"
    :bar-fetcher="getSymbolCandleStick"
    :search-symbols-fetcher="searchSymbols"
    :subscribe-callback="subscribeCallback"
    fullscreen
    :user-id="user?.userId.toString()"
    :client-id="OIDC_CONFIG.client_id"
    :scrolling="false"
    charts-storage-url="https://gateway.farabixo.com/api"
    charts-storage-api-version="v2"
    class="h-full"
    :theme="colorMode"
    @on-chart-load="(isin) => updateActiveIsin(isin)"
  />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { TvChart } from '@tradingview-api/tradingview';
import { useUser } from '@core/user';
import { searchSymbols, getSymbolCandleStick } from '@core/symbol';
import { Instrument } from '@libs/api-reference';
import { OIDC_CONFIG } from '@libs/oidc';
import { useColorMode } from '@vueuse/core';

import { useActiveSymbolIsin } from '@/modules/symbol';

type SymbolTechnicalChartPropsType = {
  symbol: Instrument;
};

const props = defineProps<SymbolTechnicalChartPropsType>();

const price = computed(() => props.symbol?.lastTradePrice);
const symbolInfo = computed(() => {
  if (props.symbol?.isin) {
    return {
      isin: props.symbol?.isin,
      symbol: props.symbol?.instrumentTitle,
      name: props.symbol?.instrumentName,
    };
  }

  return symbolInfo.value;
});

const { user } = useUser();
const { updateActiveIsin } = useActiveSymbolIsin();

const colorMode = useColorMode();

const subscribeCallback = (callback) => {
  watch(price, callback);
};
</script>

<style>
#trading-view-chart iframe {
  height: calc(100% - 32px) !important;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
</style>
